import { TextField } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import { useRef } from "react";
import { useState } from "react";

export const UpperCaseTextCellEditor =
    forwardRef((props, ref) => {
    const refValue = useRef();
    const [value, setValue] = useState("");
  
    const handleVesselNoChange = (e) => {
      setValue(e.target.value.toUpperCase());
    };
    useEffect(() => {
      const value = props?.value;
      if (value) {
        setValue(value);
      }
    }, [props.data]);
    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value;
        },
      };
    });
    return (
      <TextField
        className="w-full customDatePickerDiscount"
        required
        type="text"
        variant="outlined"
        name={props.colDef.field}
        value={value}
        onChange={handleVesselNoChange}
        inputRef={refValue}
        //   InputLabelProps={{
        //     shrink: true,
        // }}
      />
    );
  });